import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";

@Injectable({
    providedIn: 'root'
})
export class ContractExternalBillingRecordItemService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ci/contractExternalBillingRecordItems')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-list-ol';
    }

    getObjectLabels(): string[] {
        return ['subBranch', 'netPremium'];
    }

}
